export default "__VITE_ASSET__DBjLveX9__"